// src/pages/PrivacyPage.jsx
export default function PrivacyPage() {
  return (
    <section className="section" style={{ maxWidth: "800px", margin: "0 auto" }}>
      <h1>Polityka Prywatności</h1>

      <p>
        Administratorem danych osobowych jest:
        <br /><br />
        <b>Art Rafał Tołczyk</b><br />
        ul. Boya-Żeleńskiego 2, 15-198 Białystok<br />
        kontakt: kontakt@arttolczyk.pl
      </p>

      <h2>1. Jakie dane zbieramy?</h2>
      <ul>
        <li>imię i nazwisko</li>
        <li>adres e-mail</li>
        <li>adres dostawy</li>
        <li>treść zamówienia</li>
      </ul>

      <h2>2. Cele przetwarzania danych</h2>
      <ul>
        <li>realizacja zamówień</li>
        <li>kontakt z klientem</li>
        <li>wystawianie dokumentów księgowych</li>
        <li>obsługa zwrotów i reklamacji</li>
      </ul>

      <h2>3. Podstawy prawne</h2>
      <ul>
        <li>art. 6 ust. 1 lit. b RODO – wykonanie umowy</li>
        <li>art. 6 ust. 1 lit. c RODO – obowiązki podatkowe</li>
      </ul>

      <h2>4. Prawa użytkownika</h2>
      <ul>
        <li>dostęp do danych</li>
        <li>sprostowanie</li>
        <li>usunięcie</li>
        <li>ograniczenie przetwarzania</li>
        <li>skarga do UODO</li>
      </ul>

      <h2>5. Cookies</h2>
      <p>
        Strona może korzystać z plików cookie koniecznych do prawidłowego
        działania sklepu oraz statystyk odwiedzin.
      </p>
    </section>
  );
}

